<template>
  <div class="todo-menu">
    <div class="todo-menu-item" :class="{'selected': selected === 'dashboard'}">
      <router-link to="/dashboard">
        <svg-icon name="home" />
      </router-link>
    </div>
    <div class="todo-menu-item" :class="{'selected': selected === 'specialities'}">
      <router-link to="/specialities">
        <svg-icon name="arch" />
      </router-link>
    </div>
    <div class="todo-menu-item" :class="{'selected': selected === 'invoice'}">
      <router-link to="/invoice">
        <svg-icon name="calendar" />
      </router-link>
    </div>
    <div class="todo-menu-item" :class="{'selected': selected === 'hunters'}">
      <router-link to="/hunters">
        <svg-icon name="help" />
      </router-link>
    </div>
    <div class="todo-menu-item" :class="{'selected': selected === 'users'}">
      <router-link to="/users">
        <svg-icon name="user" />
      </router-link>
    </div>
    <div class="todo-menu-item" :class="{'selected': selected === 'vouchers'}">
      <router-link to="/vouchers">
        <!-- <svg-icon name="coupons" /> -->
      <svg xmlns="http://www.w3.org/2000/svg" class="svg-icon svg-fill" width="29.932" height="22.606" viewBox="0 0 29.932 22.606">
        <g id="coupon_black" transform="translate(0.111 448.363)">
          <path id="Path_194" data-name="Path 194" d="M2.219-448.02A2.861,2.861,0,0,0,.189-445.9c-.04.2-.058,1.168-.046,2.9.017,2.519.023,2.6.138,2.755.224.3.385.38.9.431a2.741,2.741,0,0,1,1.869.88,2.729,2.729,0,0,1,0,3.75,2.741,2.741,0,0,1-1.869.88c-.518.052-.679.132-.9.431-.115.155-.121.236-.138,2.755-.012,1.731.006,2.7.046,2.9a2.844,2.844,0,0,0,2.053,2.117c.5.132,24.726.132,25.226,0a2.844,2.844,0,0,0,2.053-2.117c.04-.2.058-1.168.046-2.9-.017-2.519-.023-2.6-.138-2.755-.219-.3-.385-.38-.88-.431a2.7,2.7,0,0,1-1.777-.765,2.717,2.717,0,0,1,0-3.98,2.7,2.7,0,0,1,1.777-.765c.495-.052.661-.132.88-.431.115-.155.121-.236.138-2.755.012-1.731-.006-2.7-.046-2.9a2.844,2.844,0,0,0-2.053-2.117C26.985-448.146,2.685-448.141,2.219-448.02Zm25.094,1.9a1.565,1.565,0,0,1,.276.276c.115.15.121.242.138,2.226.017,1.95.012,2.065-.086,2.065a5.326,5.326,0,0,0-1.484.644,4.609,4.609,0,0,0-2.019,3.025,4.62,4.62,0,0,0,2.91,5.113,4.221,4.221,0,0,0,.592.19c.1,0,.1.115.086,2.065-.017,1.984-.023,2.076-.138,2.226a1.566,1.566,0,0,1-.276.276l-.155.121H2.553L2.4-428.01a1.566,1.566,0,0,1-.276-.276c-.115-.149-.121-.242-.138-2.214l-.017-2.053.253-.063a4.656,4.656,0,0,0,2.048-1.173,4.609,4.609,0,0,0,1.306-4.089,4.649,4.649,0,0,0-3.353-3.629l-.247-.063v-1.967c0-2.042.012-2.174.247-2.433.282-.3-.46-.288,12.705-.276l12.234.012Z" transform="translate(0 0)" fill="#373737" stroke="#373737" stroke-width="0.5"/>
          <path id="Path_195" data-name="Path 195" d="M199.162-389.407c-2.117,5.631-5.355,14.287-5.366,14.35a5.837,5.837,0,0,0,1.679.656c.023-.023,1.26-3.3,2.749-7.264s2.721-7.259,2.738-7.3c.029-.069-.155-.161-.828-.408l-.863-.322Z" transform="translate(-182.518 -55.053)" fill="#373737" stroke="#373737" stroke-width="0.5"/>
          <path id="Path_196" data-name="Path 196" d="M134.781-346.407a2.84,2.84,0,0,0-2.272,2.318,2.789,2.789,0,0,0,1.9,3.031,3.227,3.227,0,0,0,1.518.029,2.748,2.748,0,0,0,2.042-2.646A2.753,2.753,0,0,0,134.781-346.407Zm.92,1.944a1.151,1.151,0,0,1,.3.3.641.641,0,0,1,.115.518.855.855,0,0,1-.926.857.852.852,0,0,1-.776-.529.775.775,0,0,1,.144-.972A.862.862,0,0,1,135.7-344.463Z" transform="translate(-124.729 -95.827)" fill="#373737" stroke="#373737" stroke-width="0.5"/>
          <path id="Path_197" data-name="Path 197" d="M300.157-246.83a3.038,3.038,0,0,0-1.731,1.352,2.641,2.641,0,0,0-.316,1.5,1.954,1.954,0,0,0,.236.966,2.72,2.72,0,0,0,3.71,1.323,2.77,2.77,0,0,0,1.507-2.864,2.816,2.816,0,0,0-1.9-2.226A3.663,3.663,0,0,0,300.157-246.83Zm1.168,1.91a1.016,1.016,0,0,1,.426.909.95.95,0,0,1-1.127.742.912.912,0,0,1-.592-1.306A.925.925,0,0,1,301.325-244.921Z" transform="translate(-280.827 -189.652)" fill="#373737" stroke="#373737" stroke-width="0.5"/>
        </g>
      </svg>
      </router-link>
    </div>

    <div class="todo-menu-item" :class="{'selected': selected === 'visibility'}">
      <router-link to="/visibility">
        <svg-icon name="arch" />
      </router-link>
    </div>
  </div>
</template>

<script>
  import '../icons/components'

  export default {
    props: {
      selected: String
    }
  }
</script>

<style lang="scss">
  .todo-menu {
    z-index: 200;
    position: absolute;
    display: flex;
  }

  .todo-menu {
    top: 15%;
    left: 105px;
    flex-direction: column;

    .todo-menu-item {
      padding: 22px 20px;
      // margin: 5px 0;

      &.selected {
        background-image: url('~@/img/bg-nav-selected.png');
        background-repeat: no-repeat;
        background-position: left center;
      }

      svg {
        padding-bottom: 2px;
      }
    }
  }
</style>
